module.exports = __webpack_public_path__ + "img/petdog4.37551c1e.jpg";